<pdf-viewer
    [src]="src"
    [rotation]="0"
    [original-size]="false"
    [show-all]="true"
    style="width: 100%; height: 100%;"
></pdf-viewer>
